<template lang="pug">
.donation-error
	VueFeedback(type="error")
		template(slot="feedback-title") Failed transaction.
		template(slot="feedback-content")
			p.sf-text SimplePay transaction identifier:
				strong  {{transactionId}}
			p.sf-text Please check if the details provided during the transaction are correct. If all the details were provided correctly, please contact the bank that issued your card in order to investigate the cause of the rejection.
</template>
<script>
import VueFeedback from '@ui-common/vue-feedback';
export default {
	props: {
		transactionId: {
			required: false
		}
	},

	components: {
		VueFeedback
	},
	mounted() {
		this.$scrollTo(this.$el);
	}
};
</script>

<style lang="scss" scoped>
.donation-error {
	margin-bottom: 48px;
}
</style>
